<template>
  <div class="mailbox-verification-gmail-confirmation-link-finder">
    <!-- Polling for verification -->
    <template v-if="pollingForVerification">
      <h3>Searching for a confirmation link from Gmail...</h3>
      <p>Give us a few seconds as we wait for the email to arrive.</p>
      <verification-loader />
    </template>
    <!-- Found confirmation code -->
    <template v-else-if="hasConfirmationLink">
      <h3>We found the confirmation link!</h3>
      <i class="ddi ddi-arrow-down bouncy" />
      <div class="confirmation-link-wrapper">
        <h4><a :href="confirmationLink" class="just-a-link" target="_blank">Click here and hit the "Confirm" button</a></h4>
      </div>
      <div class="bottom-centered">
        <dd-button type="text" @click="pollForVerificationEmail()">
          Not the right link? Check again.
        </dd-button>
        <dd-button type="flat" @click="$emit('confirmed')">I've clicked the link and the Confirm button.</dd-button>
      </div>
    </template>
    <!-- Did not find confirmation code -->
    <template v-else>
      <h3>We did not find a confirmation link.</h3>
      <p><br></p>
      <ul>
        <li><strong><a href="#" class="just-a-link" @click.stop.prevent="pollForVerificationEmail()">Check again</a></strong>. Sometimes
          the email may take a minute to get here.</li>
        <li><strong><a href="#" class="just-a-link" @click.stop.prevent="$emit('go-back-clicked')">Go back to the beginning</a></strong>
          and review our auto-forwarding instructions again.</li>
        <li>At a loss? <strong><a href="https://www.donedone.com/help-center" target="_blank" class="just-a-link">Reach out to us</a></strong>
          so we can help.</li>
      </ul>
    </template>
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'

export default defineComponent({
  name: 'MailboxVerificationGmailConfirmationLinkFinder',

  emits: ['confirmed', 'go-back-clicked'],

  data() {
    return {
      pollingForVerification: true,
      hasConfirmationLink: false,
      poller: null as any,
      pollCount: 0,
      pollIntervalInMS: 5000,
      pollMax: 12,
      confirmationLink: '',
    }
  },

  computed: {
    mailboxID(): number {
      return Number(this.$route.params.id)
    },
  },

  watch: {
    pollCount: {
      handler(newValue) {
        if (newValue >= this.pollMax) {
          this.endPolling()
        }
      },
    },
  },

  beforeUnmount() {
    this.endPolling()
  },

  async created() {
    this.pollForVerificationEmail()
  },

  methods: {
    endPolling() {
      clearInterval(this.poller)
      this.pollingForVerification = false
    },
    pollForVerificationEmail() {
      this.hasConfirmationLink = false
      this.pollingForVerification = true
      this.pollCount = 0
      this.poller = setInterval(async () => {
        this.pollCount++
        await this.getMostRecentGmailConfirmationLink()
      }, this.pollIntervalInMS)
    },
    async getMostRecentGmailConfirmationLink() {
      try {
        const response = await MailboxesAPI.get_MostRecentGmailConfirmationLink(
          this.mailboxID,
        )
        this.confirmationLink = response.link
        this.hasConfirmationLink = true
        this.endPolling()
      } catch (err) {
        console.log('No confirmation link found.')
      }
    },
  },
})
</script>

<style lang="scss">
.mailbox-verification-gmail-confirmation-link-finder {
  display: flex;
  flex-direction: column;
  align-items: center;

  .confirmation-link-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 10px;
  }
}
</style>
